export default __webpack_public_path__ + "static/media/683.cfd937ed.gif";